import EventDetail from '../features/Events/components/EventsDetail';
import EventsTab from '../features/Events/components/EventsTab';
import Gnn from '../features/Gnn/components/Gnn';
import RnrOverview from '../features/RnR/RnROverview/components/RnROverview';
import Winners from '../features/RnR/RnRWinners/components/Winners';
import BroadCast from '../features/Announcement/components/Announcements';
import {
  AboutMePage,
  Announcements,
  Blocked,
  Delights,
  Gift,
  ProfilePage,
  RnR,
  Shabash,
  ViewportSettings,
} from '../pages';
import { Navigate } from 'react-router-dom';
import ShabashWinners from '../features/Shabash/components/ShabashWinners';
import ShabashOverview from '../features/Shabash/ShabashOverview/ShabashOverview';
import NewsDetail from '../features/Gnn/components/NewsDetail';
import Comments from '../features/Comment/components/Comments';
import RnRDrawer from '../features/RnR/RnRForm/components/RnRDrawer';
import ShabashDrawer from '../features/Shabash/components/ShabashDrawer';
import Users from '../pages/Users';
import PermissionManager from '../features/Users/components/PermissionManager';
import Resume from '../features/Resume/components/Resume';
import UserSettings from '../features/Users/components/UserSettings';
import AdminRnR from '../features/RnR/AdminRnR/AdminRnR';
import AdminShabash from '../features/Shabash/AdminShabash/AdminShabash';
import LeaveManagement from '../features/WebView/components/LeaveManagement';
import GatewayBox from '../features/WebView/components/GatewayBox';
import AdminDelights from '../features/Delight/AdminDelights/AdminDelights';
import { Grid } from '@mui/material';
import { variants } from '../variants/variants';
import ManageGiftAdmin from '../features/Gift/components/Admin/ManageGiftAdmin';

const AdminRoutes = [
  { path: '', element: <Navigate to={'user'} /> },
  {
    path: 'gnn',
    element: (
      <Grid
        container
        sx={{
          backgroundColor: '#EEF5FF',
          padding: 1,
          border: 1,
          height: 'calc(100vh - 80px)',
          overflow: 'hidden',
          borderRadius: variants.boxRadius.NAVBAR,
          borderColor: 'divider',
          width: '80%',
        }}
      >
        <Gnn />
      </Grid>
    ),
  },
  { path: 'leave', element: <LeaveManagement /> },
  { path: 'gatewaybox', element: <GatewayBox /> },
  {
    path: 'announcement',
    element: <Announcements />,
    children: [
      { path: '', element: <Navigate to={'board'} /> },
      { path: 'board', element: <BroadCast /> },
      {
        path: 'events',
        element: <EventsTab />,
        children: [{ path: ':id', element: <EventDetail /> }],
      },

      { path: 'gnn', element: <Gnn /> },
      { path: 'gnn/:id', element: <NewsDetail /> },
    ],
  },
  {
    path: 'profile/:empCode',
    element: <ProfilePage />,
    children: [
      { path: 'comment', element: <Comments /> },
      { path: 'rnr', element: <RnRDrawer /> },
      { path: 'shabash', element: <ShabashDrawer /> },
      { path: 'resume', element: <Resume /> },
    ],
  },
  { path: 'aboutme/:empCode', element: <AboutMePage /> },
  {
    path: 'rnr',
    element: <RnR />,
    children: [
      { path: '', element: <AdminRnR /> },
      { path: 'overview', element: <RnrOverview /> },
      { path: 'winners', element: <Winners /> },
    ],
  },
  { path: 'delights', element: <AdminDelights /> },

  {
    path: 'gift',
    element: <ManageGiftAdmin />,
  },

  {
    path: 'shabash',
    element: <Shabash />,
    children: [
      { path: '', element: <AdminShabash /> },
      { path: 'winners', element: <ShabashWinners /> },
      { path: 'overview', element: <ShabashOverview /> },
    ],
  },
  {
    path: 'user',
    element: <Users />,
    children: [
      { path: ':empCode', element: <UserSettings /> },
      { path: 'permissions', element: <PermissionManager /> },
    ],
  },
  {
    path: 'settings',
    element: <ViewportSettings />,
  },
];

export default AdminRoutes;
